export const COMPETITIONS_FORM_SUBMIT = 'COMPETITIONS_FORM_SUBMIT';
export const COMPETITIONS_FORM_SUBMIT_SUCCESS = 'COMPETITIONS_FORM_SUBMIT_SUCCESS';
export const COMPETITIONS_FORM_SUBMIT_FAIL = 'COMPETITIONS_FORM_SUBMIT_FAIL';

export const COMPETITIONS_FORM_ACTIONS = [
  COMPETITIONS_FORM_SUBMIT,
  COMPETITIONS_FORM_SUBMIT_SUCCESS,
  COMPETITIONS_FORM_SUBMIT_FAIL,
] as const;
